import { makeAutoObservable } from "mobx";
import { SearchUserAccount } from "app/common/Model/SearchObject";
import {
    pagingUserAccount,
    deleteUserAccount,
    saveOrUpdateUserAccount,
    getUserAccountById,
    removeUserAccount
} from 'app/services/UserAccountService';
import {
    saveOrUpdateUserStaff
} from 'app/services/StaffService';
import { UserAccount } from "app/common/Model/UserAccount";
import { toast } from "react-toastify";
import { PAGESIZE_ALL } from "app/common/LocalConst";

export default class UserAccountStore {
    listAllUserAccount = [];
    searchUserAccount = new SearchUserAccount();
    pageUserAccount = null;
    selectedUserAccount = null;
    openFormCreateOrEdit = null;
    openConfirmDeleteUserAccount = null;

    openResetPassword = null;
    openChangePassword = null;

    constructor() {
        makeAutoObservable(this);
    }

    getAllUserAccount = () => {
        if (this.listAllUserAccount?.length === 0) {
            pagingUserAccount({ pageIndex: 1, pageSize: PAGESIZE_ALL }).then(({ data }) => {
                this.listAllUserAccount = data.content;
            })
        }
    }

    pagingUserAccount = async () => {
        try {
            const { data } = await pagingUserAccount(this.searchUserAccount);
            this.pageUserAccount = data;
        } catch (error) {
            console.error("Lỗi khi phân trang tài khoản người dùng:", error);
            // Bạn có thể xử lý thêm ở đây, ví dụ:
            // this.$toast.error("Đã xảy ra lỗi khi tải danh sách tài khoản.");
        }
    };
    handleChangeFormSearch = (searchUserAccount) => {
        this.searchUserAccount = { ...this.searchUserAccount, ...searchUserAccount };
        // this.searchUserAccount = checkSearchObject(this.searchUserAccount, searchUserAccount);
        this.pagingUserAccount();
    }

    handleOpenFormCreateOrEdit = (userAccountId) => {
        if (Boolean(userAccountId)) {
            getUserAccountById(userAccountId).then(({ data }) => {
                this.selectedUserAccount = data;
                this.openFormCreateOrEdit = true;
            }).catch(function (error) {
                console.error(error);
                toast.error("Lấy dữ liệu không thành công");
            });
        } else {
            this.selectedUserAccount = new UserAccount();
            this.openFormCreateOrEdit = true;
        }
    }

    saveUserAccount = (userAccount, { setSubmitting }) => {
        saveOrUpdateUserAccount(userAccount).then(() => {
            this.selectedUserAccount = null;
            toast.success("Lưu tài khoản người dùng thành công!");
            this.pagingUserAccount();
            this.handleClosePopup();
            this.listAllUserAccount = [];
        }).catch(function (error) {
            console.error(error);
            toast.error("Lưu tài khoản người dùng thất bại!");
        }).finally(function () {
            setSubmitting(false);
        });
    }

    saveStaffUserAccount = (userAccount) => {
        saveOrUpdateUserStaff(userAccount).then(() => {
            this.selectedUserAccount = null;
            toast.success("Lưu tài khoản người dùng thành công!");
            this.pagingUserAccount();
            this.handleClosePopup();
            this.listAllUserAccount = [];
        }).catch(function (error) {
            console.error(error);
            toast.error("Lưu tài khoản người dùng thất bại!");
        })
    }

    // Hàm xử lý khi người dùng nhấn nút Xóa tài khoản trên danh sách.
    // Chỉ ghi nhận id tài khoản và mở ConfirmPopup xác nhận.
    handleDeleteUserAccount = (userAccount) => {
        this.openConfirmDeleteUserAccount = userAccount;
    }

    // Hàm xác nhận xóa tài khoản sau khi người dùng đồng ý trong ConfirmPopup.
    handleConfirmDeleteUserAccount = () => removeUserAccount(this.openConfirmDeleteUserAccount)
        .then(({ data }) => {
            if (data?.responseStatus === 1) {
                if (this.searchUserAccount?.pageIndex > 1 && this.pageUserAccount?.content?.length === 1) {
                    this.searchUserAccount.pageIndex -= 1;
                }
                toast.success("Xóa tài khoản người dùng thành công!");
                this.pagingUserAccount();
                this.handleClosePopup();
            } else {
                toast.error(data?.message)
            }

        }).catch(function (error) {
            console.error(error);
            toast.error("Xóa tài khoản người dùng thất bại");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteUserAccount = null;
    }


    // Mở popup ResetPasswordPopup với username được truyền vào.
    handleOpenResetPassword = (userName) => {
        this.openResetPassword = userName;
    }
    // Mở popup ChangePasswordPopup với username được truyền vào.
    handleOpenChangePassword = (userName) => {
        this.openChangePassword = userName;
    }

    // Đóng các popup thay đổi/reset mật khẩu.
    handleClosePassword = () => {
        this.openResetPassword = null;
        this.openChangePassword = null;

    }

    resetStore = () => {
        this.searchUserAccount = new SearchUserAccount();
        this.pageUserAccount = null;
        this.selectedUserAccount = null;
        this.openFormCreateOrEdit = null;
        this.openConfirmDeleteUserAccount = null;
    }
}